var _path;
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h-1.5v-4.5C29.5 8.262 25.238 4 20 4s-9.5 4.262-9.5 9.5V18H9a3 3 0 00-3 3v12a3 3 0 003 3h22a3 3 0 003-3V21a3 3 0 00-3-3zm-6.5 0h-9v-4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5V18z"
  })));
}
export default SvgLock;